import { useState } from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// RP09 (D10 C) — « Recevoir un lien de connexion » : l'e-mail saisi reçoit un lien
// d'accès direct (entreprise, client, AMO, partenaire). Le message affiché est le même
// que le compte existe ou non.
export default function LienConnexionForm({ origine = 'bureau', emailInitial = '', onFermer }) {
  const [email, setEmail] = useState(emailInitial);
  const [envoi, setEnvoi] = useState(false);
  const [message, setMessage] = useState('');
  const [erreur, setErreur] = useState('');

  const envoyer = async (e) => {
    e.preventDefault();
    if (!email) return;
    setEnvoi(true);
    setErreur('');
    try {
      const { data } = await axios.post(`${API_URL}/api/auth/lien-connexion`, { email, origine });
      setMessage(data?.message || 'Si un compte correspond à cette adresse, un lien de connexion vient d\'être envoyé.');
    } catch (err) {
      setErreur(err?.response?.status === 429
        ? 'Trop de demandes. Réessayez dans quelques minutes.'
        : 'Envoi impossible pour le moment. Réessayez.');
    } finally {
      setEnvoi(false);
    }
  };

  if (message) {
    return (
      <div data-testid="lien-connexion-envoye">
        <p className="text-sm text-[#4A4A4A] mb-4">{message}</p>
        {onFermer && (
          <Button className="w-full rounded-none bg-[#2C2C2C] hover:bg-[#4A4A4A]" onClick={onFermer}>
            Retour à la connexion
          </Button>
        )}
      </div>
    );
  }

  return (
    <form onSubmit={envoyer} data-testid="lien-connexion-form">
      <h2 className="text-lg font-semibold mb-2" style={{ fontFamily: 'DM Serif Display, serif' }}>
        Recevoir un lien de connexion
      </h2>
      <p className="text-sm text-[#6B6B6B] mb-4">
        Entreprise, client, AMO ou partenaire : recevez par e-mail un lien qui vous connecte sans mot de passe.
      </p>
      <Input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="vous@exemple.fr"
        className="h-12 rounded-none mb-3"
        required
        data-testid="lien-connexion-email"
      />
      {erreur && <p className="text-sm text-[#8B3A3A] mb-3">{erreur}</p>}
      <div className="flex gap-2">
        {onFermer && (
          <Button type="button" variant="outline" className="flex-1 rounded-none" onClick={onFermer}>Annuler</Button>
        )}
        <Button type="submit" className="flex-1 rounded-none bg-[#C75B39] hover:bg-[#D97B5C]" disabled={envoi} data-testid="lien-connexion-submit">
          {envoi ? 'Envoi…' : 'Recevoir le lien'}
        </Button>
      </div>
    </form>
  );
}
